import React from 'react';

const GRUPOS = {
    1: 'Aportes y Cargas Sociales',
    2: 'Gastos Bancarios, Legales, Administrativos y Registrales',
    3: 'Impuestos y Servicios',
    4: 'Mantenimiento y Abonos',
    5: 'Reparaciones',
    6: 'Remuneraciones',
    7: 'Seguridad Privada',
    8: 'Seguros',
};

const isSummaryRow = (detalle) => {
    const d = (detalle || '').trim();
    return (
        d.startsWith('Subtotal:') ||
        d.startsWith('% Gastos:') ||
        d === 'Total' ||
        d === 'Previsión' ||
        d === 'Total + Previsión' ||
        d === '*** % Gastos por Grupo:'
    );
};

const formatARS = (value) =>
    value != null
        ? new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 2 }).format(value)
        : '';

const formatFecha = (fechaStr) => {
    if (!fechaStr) return '';
    return new Date(fechaStr).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const PdfDetalleGastos = ({ gastos = [], periodo }) => {
    const formatPeriodo = (date) => {
        if (!date) return '';
        const d = new Date(date);
        return d.toLocaleDateString('es-AR', { month: 'long', year: 'numeric' });
    };

    // Agrupar por grupoGastoBarrioId excluyendo filas de resumen global
    const gruposConDatos = Object.keys(GRUPOS)
        .map(Number)
        .map((grupoId) => {
            const filaGrupo = gastos.filter((r) => r.grupoGastoBarrioId === grupoId);
            const subtotalRow = filaGrupo.find((r) => (r.detalle || '').trim().startsWith('Subtotal:'));
            const filasReales = filaGrupo.filter((r) => !isSummaryRow(r.detalle));
            return { grupoId, nombre: GRUPOS[grupoId], filasReales, subtotalRow };
        })
        .filter((g) => g.filasReales.length > 0);

    const totalRow = gastos.find((r) => (r.detalle || '').trim() === 'Total');
    const previsionRow = gastos.find((r) => (r.detalle || '').trim() === 'Previsión');
    const totalPrevisionRow = gastos.find((r) => (r.detalle || '').trim() === 'Total + Previsión');

    return (
        <>
            <div className="pdf-section-title">
                DETALLE DE GASTOS — {formatPeriodo(periodo)?.toUpperCase()}
            </div>

            {gruposConDatos.map(({ grupoId, nombre, filasReales, subtotalRow }) => (
                <div key={grupoId} style={{ marginBottom: '12px' }}>
                    <div className="pdf-row-section-header" style={{ padding: '4px 8px', background: '#d9d9d9', fontWeight: 'bold', fontSize: '8.5pt', marginBottom: '2px' }}>
                        {nombre}
                    </div>
                    <table className="pdf-data-table" style={{ marginBottom: '4px' }}>
                        <thead>
                            <tr>
                                <th style={{ width: '70px' }}>Fecha</th>
                                <th>Proveedor</th>
                                <th>Detalle</th>
                                <th className="pdf-col-number" style={{ width: '80px' }}>Ordinario</th>
                                <th className="pdf-col-number" style={{ width: '85px' }}>Extraordinario</th>
                                <th className="pdf-col-number" style={{ width: '90px' }}>No Distrib.</th>
                                <th className="pdf-col-number" style={{ width: '80px' }}>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filasReales.map((row, i) => (
                                <tr key={i}>
                                    <td>{formatFecha(row.fecha)}</td>
                                    <td>{row.nombreProveedor}</td>
                                    <td>{row.detalle}</td>
                                    <td className="pdf-col-number">{formatARS(row.gastoOrdinario)}</td>
                                    <td className="pdf-col-number">{formatARS(row.gastoExtraordinario)}</td>
                                    <td className="pdf-col-number">{formatARS(row.gastoNoDistribuible)}</td>
                                    <td className="pdf-col-number">{formatARS(row.totalGasto)}</td>
                                </tr>
                            ))}
                            {subtotalRow && (
                                <tr className="pdf-row-subtotal">
                                    <td colSpan={3}>{subtotalRow.detalle}</td>
                                    <td className="pdf-col-number">{formatARS(subtotalRow.gastoOrdinario)}</td>
                                    <td className="pdf-col-number">{formatARS(subtotalRow.gastoExtraordinario)}</td>
                                    <td className="pdf-col-number">{formatARS(subtotalRow.gastoNoDistribuible)}</td>
                                    <td className="pdf-col-number">{formatARS(subtotalRow.totalGasto)}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            ))}

            {/* Totales globales */}
            {(totalRow || previsionRow || totalPrevisionRow) && (
                <table className="pdf-data-table" style={{ marginTop: '8px' }}>
                    <tbody>
                        {totalRow && (
                            <tr className="pdf-row-total">
                                <td colSpan={6}>Total General</td>
                                <td className="pdf-col-number">{formatARS(totalRow.totalGasto)}</td>
                            </tr>
                        )}
                        {previsionRow && (
                            <tr className="pdf-row-subtotal">
                                <td colSpan={6}>Previsión</td>
                                <td className="pdf-col-number">{formatARS(previsionRow.totalGasto)}</td>
                            </tr>
                        )}
                        {totalPrevisionRow && (
                            <tr className="pdf-row-total">
                                <td colSpan={6}>Total + Previsión</td>
                                <td className="pdf-col-number">{formatARS(totalPrevisionRow.totalGasto)}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            )}
        </>
    );
};

export default PdfDetalleGastos;
